
import Vue from 'vue'
import { LinkButton } from '@/components/buttons'

export default Vue.extend({
   name: 'AccountTypeButtonSelector',
   computed: {
      accountType(): string {
         return this.$store.state.accountType
      },
      hasLoggedInUser(): boolean {
         return this.$store.getters.hasLoggedInUser
      },
      partyName(): boolean {
         return this.$store.state.modelData.PartyName
      },
      partyEmail(): string {
         return this.$store.state.modelData.PartyEmail
      },
   },
   methods: {
   },
   components: {
      LinkButton,
   },
})
